import {Service} from "platform/service/Service";
import {Reducer} from "platform/redux/Reducer";
import {ServiceType} from "enum/ServiceType";
import AppReducer from "core/redux/app/AppReducer";
import AppEngine from "core/engine/AppEngine";
import {Dpk} from "platform/dpk/Dpk";
import {DpkHandler} from "core/dpk/DpkHandler";

export class AppService implements Service<AppEngine, any> {

    private static _instance: AppService;

    private constructor() {
    }

    public static instance(): AppService {
        return this._instance || (this._instance = new this());
    }

    public async setup<Props>(props?: Props): Promise<void> {
        await this.engine().setup();
        Dpk.setHandler(new DpkHandler());
    }

    public name(): string {
        return ServiceType.App;
    }

    public reducers(): Array<Reducer<any>> {
        return [AppReducer.instance()];
    }

    public engine(): AppEngine {
        return AppEngine.instance();
    }

    public state(): any {
        return undefined;
    }
}
